import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=68300c3e&scoped=true&"
import script from "./Settings.vue?vue&type=script&lang=js&"
export * from "./Settings.vue?vue&type=script&lang=js&"
import style0 from "./Settings.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Settings.vue?vue&type=style&index=1&id=68300c3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68300c3e",
  null
  
)

export default component.exports